<template>
    <div class="salesContractMonth">
        <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
        >
            <el-menu-item index="1">
                按销售区域
            </el-menu-item>
            <el-menu-item index="2">
                按合同类型
            </el-menu-item>
            <el-menu-item index="3">
                按业务员
            </el-menu-item>
        </el-menu>
        <salesArea v-if="activeIndex == 1"></salesArea>
        <typeOfContract v-if="activeIndex == 2"></typeOfContract>
        <salesman v-if="activeIndex == 3"></salesman>
        <!-- <salesContractComp v-if="showContract" :alert-status="alertStatus" @closeChildAlert="closeChildFn"></salesContractComp> -->
    </div>
</template>

<script>
// import addBgImages from './utils';
import salesArea from './components/monthDataAnalysis/salesArea';
import typeOfContract from './components/monthDataAnalysis/typeOfContract';
import salesman from './components/monthDataAnalysis/salesman';
export default {
    data() {
        return {
            activeIndex: '1',
        };
    },
    components: {
        salesArea,
        typeOfContract,
        salesman,
    },
    methods: {
        handleSelect(key) {
            this.activeIndex = key;
        },
    },
};

</script>
<style lang='stylus'>
.salesContractMonth
    height 100%
    display flex
    flex-direction column
    .el-menu
        border-bottom none
        padding 20px
        padding-top 10px
        padding-bottom 0
        .el-menu-item
            padding 0 1px
            height 40px
            line-height 40px
            margin-right 20px
            color #333333
            font-size 16px
        .is-active
            color #D6000F
            border-color #D6000F
.salesContractMonthBox
    height 100%
    display flex
    padding 20px
    flex-direction column
    background #fff
    overflow-y auto
    .el-table__fixed-right thead tr th
        &:last-child
            width 100px
            background #F5F2ED !important
            color #823802 !important
            border-left 1px solid #000
        &:nth-last-child(2)
            width 100px
            background #F5F2ED !important
            color #823802 !important
            border-left 1px solid #000
    .el-table__fixed-body-wrapper tbody tr td
        &:last-child
            color #C9661E !important
        &:nth-last-child(2)
            color #C9661E !important
        &:nth-last-child(3)
            color #C9661E !important
    .el-table__fixed-footer-wrapper table tbody tr
        td
            background none
            color #C9661E
            &:first-child
                background #F5F2ED
                color #823802
                font-size 16px
    .el-table__footer-wrapper table tbody td
        background none
        color #C9661E
    .top-echarts-two
        // flex 1
        width 100%
        overflow hidden
        // height 600px
        height 360px
        .echarts-total
            height: 100%;
            width calc(50% - 10px)
            // width 100%
            // height 50%
            float left
            padding 20px
            border 1px solid #D7D7D7
            box-sizing border-box
            .title-box
                display flex
                justify-content space-between
                flex 1
                h1
                    color #333333
                    font-size 18px
                    &:before
                        content '`'
                        width 6px
                        height 20px
                        background #4D7DE0
                        color #4D7DE0
                        margin-right 10px
                span
                    color #1577D2
                    height 25px
                    padding 0 20px;
                    font-size 14px
                    cursor pointer
                    border 1px solid #1577D2
        .echarts-left
            margin-right 20px
    .table-list
        margin-top 10px
        width 100%
        height calc(100% - 360px)
        padding-bottom 20px
        .el-table
            // overflow: auto;
            // &:after
            //     position:relative !important;
            // .el-table__header
            //     border-collapse: collapse;
            // .el-table__body-wrapper,
            // .el-table__header-wrapper,
            // .el-table__footer-wrapper
            //     overflow: visible;
            .el-table__header
                border-collapse: collapse;
            thead tr th
                color #022782
                font-size 16px
                text-align center
                padding 0
            tbody tr td
                height 40px
                text-align center
                padding 0
                font-size 14px
    .export
        margin-top 10px
        height 35px
        .export_btn
            border: none;
            height: 36px;
            font-size: 14px;
            min-width: 36px;
            line-height: 36px;
            cursor: pointer;
            padding: 0 20px;
            border-radius: 2px;
            background: #f1f4f7;
            color: #2978ff;
            text-align: center;
</style>
